import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type {
  LeaseRentersInsuranceSettings,
  LeaseRentersInsuranceSettingsCompanyPortalTypedSettingsWithOverridesDocument,
} from '~/swagger/settings/Api';

const baseUrl = `${envConfig.service.settings}/company-portal/settings/leaserentersinsurance`;

export class LeaseRentersInsuranceSettingsRepository extends BaseRestRepository {
  public async getAllLeaseRentersInsuranceSettings(): Promise<LeaseRentersInsuranceSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = baseUrl + '/with-overrides';
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getLeaseRentersInsuranceSettingsByLevel(level: string, levelId: string): Promise<LeaseRentersInsuranceSettings> {
    const url = `${baseUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateLeaseRentersInsuranceSettings(payload: LeaseRentersInsuranceSettings): Promise<LeaseRentersInsuranceSettings> {
    const url = `${baseUrl}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
      }),
    });
    return this.getJsonResponse(response);
  }

  public async updateLeaseRentersInsuranceSettingsByLevel(
    level: string,
    levelId: string,
    payload: LeaseRentersInsuranceSettings
  ): Promise<LeaseRentersInsuranceSettings> {
    const url = baseUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
        targets: [{ level, levelId }],
      }),
    });
    return this.getJsonResponse(response);
  }

  public async deleteLeaseRentersInsuranceSettingsByLevel(level: string, levelId: string): Promise<void> {
    const url = `${baseUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response);
  }
}
